module.exports = __webpack_public_path__ + "img/weather.52915221.svg";